import { SelectedEventT } from '../../features/extensions/pages/extensions-page/dependencies-graph/types';
import { myExtensionsPath } from '../../features/extensions/routes';
import { ExtensionsView } from '../../types/extensions';

type MyExtensionsQuery = {
  page: string;
  pageSize: string;
  name?: string;
  queues?: string;
  events: SelectedEventT;
  view: ExtensionsView;
};
const myExtensionsDefaultQuery = {
  page: '1',
  pageSize: '15',
  view: 'list',
} as const;

export const getMyExtensionsPathWithQuery = (
  query: Partial<MyExtensionsQuery> = myExtensionsDefaultQuery
) => {
  const pathQuery = { ...myExtensionsDefaultQuery, ...query };
  const queryString = new URLSearchParams(pathQuery).toString();

  return `${myExtensionsPath()}?${queryString}`;
};

export const settingsPath = () => '/settings' as const;
